import { render, staticRenderFns } from "./levelUp.vue?vue&type=template&id=0a214ead"
import script from "./levelUp.vue?vue&type=script&lang=js"
export * from "./levelUp.vue?vue&type=script&lang=js"
import style0 from "./levelUp.vue?vue&type=style&index=0&id=0a214ead&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports